import classNames from 'classnames';

import { Button, ButtonSize, ButtonWithState } from '@xemplo/button';

import * as S from './footer.styles';
import { ModalFooterProps } from './footer.types';

export const ModalFooterTestId = {
  footerContainer: 'modal-footer-container',
  extra: 'modal-footer-extra',
  primaryButton: 'modal-footer-primary-button',
  secondaryButton: 'modal-footer-secondary-button',
  tertiaryButton: 'modal-footer-tertiary-button',
};

export const ModalFooter = ({
  btnPrimary,
  btnSecondary,
  btnTertiary,
  extra,
  className,
  showKeyline,
}: ModalFooterProps) => {
  if (!(btnPrimary || btnSecondary || btnTertiary || extra)) return null;
  const hasPrimaryAndSecondary = !!(btnPrimary && btnSecondary);
  return (
    <S.FooterContainer
      data-testid={ModalFooterTestId.footerContainer}
      className={classNames(className, {
        hasPrimaryOrSecondary: !hasPrimaryAndSecondary,
        showKeyline,
      })}
    >
      {extra && (
        <div className="extra" data-testid={ModalFooterTestId.extra}>
          {extra}
        </div>
      )}
      {btnPrimary && (
        <ButtonWithState
          {...btnPrimary}
          size={btnPrimary?.size ?? ButtonSize.Medium}
          className="primary-button"
          testId={ModalFooterTestId.primaryButton}
        >
          {btnPrimary.label}
        </ButtonWithState>
      )}
      {btnSecondary && (
        <Button
          {...btnSecondary}
          size={btnSecondary?.size ?? ButtonSize.Medium}
          className="secondary-button"
          testId={ModalFooterTestId.secondaryButton}
        >
          {btnSecondary.label}
        </Button>
      )}
      {btnTertiary && (
        <Button
          {...btnTertiary}
          size={btnTertiary?.size ?? ButtonSize.Medium}
          className="tertiary-button"
          testId={ModalFooterTestId.tertiaryButton}
        >
          {btnTertiary.label}
        </Button>
      )}
    </S.FooterContainer>
  );
};
